import { render, staticRenderFns } from "./urgent-list.vue?vue&type=template&id=72a4516c&scoped=true&"
import script from "./urgent-list.vue?vue&type=script&lang=js&"
export * from "./urgent-list.vue?vue&type=script&lang=js&"
import style0 from "./bill.scss?vue&type=style&index=0&id=72a4516c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4516c",
  null
  
)

export default component.exports